import z from "zod";

export const loginFormDataSchema = z.object({
  username: z.string().optional(),

  redirectTo: z.string().optional(),
});

export type LoginFormDataProps = z.infer<typeof loginFormDataSchema>;
